module.exports = __webpack_public_path__ + "static/media/filter-time.ba844809.svg";